import { YupSchema } from 'services/yup/types'
import { yupArray, yupBoolean, yupNumber } from 'services/yup'
import { packageBaseVS, presetBaseVS } from './packageBase'
import {
  DrinkPackage,
  DrinkPreset,
  DrinkVariantPreset,
} from 'services/api/entities/catalog/packages/drinkPackage'
import { isIdUniqueCFG } from 'services/validations/common'

const drinkVariantPresetVS: YupSchema<DrinkVariantPreset> = presetBaseVS.shape({
  id: yupNumber().required(),
  drinksPerPerson: yupNumber().required(),
})

const drinkPresetVS: YupSchema<DrinkPreset> = presetBaseVS.shape({
  variants: yupArray(drinkVariantPresetVS).test(isIdUniqueCFG).required(),
})

export const drinkPackageVS: YupSchema<DrinkPackage> = packageBaseVS.shape({
  products: yupArray(drinkPresetVS).test(isIdUniqueCFG).min(1),
  isBundledPackage: yupBoolean().required(),
})
